import { useEffect, useState, useRef } from "react";

const DEFAULT_TIMEOUT_GAP = 10000;

  /**
   * Rotate through an array of items with a given timeout gap.
   * @param {boolean} startRotation - if true, start rotation
   * @param {any[]} items - items to rotate through
   * @param {number} [timeoutGap] - time in ms between each rotation (default is 10s)
   * @return {Array} - [currentItem, currentIndex, showNextItem]
   */
export function useRotator(startRotation, items = [], timeoutGap = DEFAULT_TIMEOUT_GAP) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const intervalRef = useRef(null);

  const showNextItem = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
  }

  useEffect(() => {
    // If no rotation, or no items, clear interval
    if (!startRotation || items.length === 0) {
      clearInterval(intervalRef.current);
      return;
    }

    // Start rotation
    intervalRef.current = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
    }, timeoutGap);

    return () => clearInterval(intervalRef.current);
  }, [startRotation, items, timeoutGap]);

  useEffect(() => {
    if (startRotation) setCurrentIndex(0);
  }, [startRotation]);

  const safeIndex = items.length === 0 ? 0 : currentIndex % items.length;
  return [items[safeIndex], safeIndex, showNextItem];
}
